import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
  IconButton,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useDispatch, useSelector } from "react-redux";
import { teamLeaveTable as tableDef } from "../../../config/grid-columns-defs";
import { handleAxiosError } from "../../../config/action-config";
import { Controller, useForm } from "react-hook-form";
import { showAlert } from "../../../actions/alert";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@material-ui/core";
import BetterControlledTable from "../../../component/BetterControlledTable";
import {
  approveLeave,
  createLeave,
  getLeaves,
  getTeamLeaves,
} from "../../../api/leaves";
import { CheckCircle, HighlightOff, Summarize } from "@mui/icons-material";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import dayjs from "dayjs";

const useStyles = makeStyles((theme) => ({
  textfeild: {
    "& .MuiFilledInput-root": {
      color: "#fff !important",
    },
  },
}));
export default function TeamLeavesManagement() {
  const classes = useStyles();
  let obj = tableDef.find((o) => o.headerName === "Action");
  const user = useSelector((state) => state.user);
  const dialogAction = useSelector((state) => state.dialog);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [createDialogOpen, setCreateDialogOpen] = useState(false);
  const [tableRefreshCount, setTableRefreshCount] = useState(0);
  const [emailFilter, setEmailFilter] = useState("");
  const [nameFilter, setNameFilter] = useState("");

  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  addAdditionalColumn(obj, dispatch, user);
  useEffect(() => {
    if (!dialogAction.type) return;
    switch (dialogAction.type) {
      case "VIEW":
        dispatch({ type: "" });
        navigate(`${dialogAction.data.employee_id}`);
        break;
      case "APPROVE":
        dispatch({ type: "" });
        approveReject(dialogAction.data.id, "Approved");
        break;
      case "REJECT":
        dispatch({ type: "" });
        approveReject(dialogAction.data.id, "Rejected");
        break;
      default:
        break;
    }
  }, [dialogAction]);

  function refreshTable(e) {
    e?.preventDefault();
    setTableRefreshCount((prev) => prev + 1);
  }
  async function getRows(limit, offset) {
    try {
      const { data } = await getTeamLeaves(
        {
          email: emailFilter,
          firstname: nameFilter,
          year: selectedYear,
          limit,
          offset,
        },
        user.token
      );
      return {
        rows: data.data.leaves,
        total: data.data.total,
        error: false,
      };
    } catch (error) {
      handleAxiosError(error, dispatch);
      return { error: true };
    }
  }
  useEffect(() => {
    refreshTable();
  }, [emailFilter, nameFilter, selectedYear]);
  async function approveReject(id, status) {
    try {
      const { data } = await approveLeave(id, { status: status }, user.token);
      dispatch(showAlert(data.msg));
      refreshTable();
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }
  return (
    <Box className="pmt-container-box">
      <Box component="main" sx={{ pb: 1 }}>
        <Typography variant="h1" className="pmt-headings-h1">
          Team Leaves
        </Typography>
      </Box>
      <Box className="pmt-title-box">
        <Box className="typography-title">
          <TextField
            label="Email"
            fullWidth
            variant="outlined"
            className={classes.textfeild}
            value={emailFilter}
            onChange={(e) => setEmailFilter(e.target.value)}
          />
          <Box sx={{ pr: 1 }}></Box>
          <TextField
            label="Name"
            fullWidth
            variant="outlined"
            className={classes.textfeild}
            value={nameFilter}
            onChange={(e) => setNameFilter(e.target.value)}
          />
          <Box sx={{ pr: 1 }}></Box>
          <FormControl fullWidth>
            <InputLabel id="year-label">Year</InputLabel>
            <Select
              labelId="year-label"
              value={selectedYear}
              onChange={(e) => setSelectedYear(e.target.value)}
            >
              {Array.from(
                { length: 24 },
                (_, i) => new Date().getFullYear() - i
              ).map((year) => (
                <MenuItem key={year} value={year}>
                  {year}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Box>
      <br />

      <div className="pmt-controll-table">
        <BetterControlledTable
          hasActionButtons={false}
          getTableRows={getRows}
          columns={tableDef}
          perPage={10}
          refreshCounter={tableRefreshCount}
        />
      </div>

      <AddLeaveDialog
        open={createDialogOpen}
        setOpen={setCreateDialogOpen}
        onRefresh={refreshTable}
        disableEscapeKeyDown
      />
    </Box>
  );
}

function addAdditionalColumn(obj, dispatch, user) {
  if (obj === undefined) {
    tableDef.unshift({
      headerName: "Action",
      field: "actions",
      minWidth: 150,
      resizable: true,
      headerClass: "justify-center",
      cellClass: "justify-center",
      cellRendererFramework: (params) => (
        <>
          <IconButton
            color="info"
            title="Leave Summary"
            onClick={() => {
              dispatch({ type: "VIEW", data: params.data });
            }}
          >
            <Summarize fontSize="inherit" />
          </IconButton>
          {user.role === "Admin" ? (
            <>
              <IconButton
                color="info"
                title="Approve"
                onClick={() => {
                  dispatch({ type: "APPROVE", data: params.data });
                }}
              >
                <CheckCircle fontSize="inherit" />
              </IconButton>
              <IconButton
                color="info"
                title="Reject"
                onClick={() => {
                  dispatch({ type: "REJECT", data: params.data });
                }}
              >
                <HighlightOff fontSize="inherit" />
              </IconButton>
            </>
          ) : (
            <></>
          )}
        </>
      ),
    });
  }
}

const emptyNewLeaveData = {
  type_of_leave: "",
  reason_of_leave: "",
  start_date: "",
  end_date: "",
  status: "pending",
  day_off: "",
};
// ... (import statements)

function AddLeaveDialog({ open, setOpen, onRefresh }) {
  const user = useSelector((state) => state.user);
  const [data, setData] = useState(emptyNewLeaveData);
  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm({ defaultValues: emptyNewLeaveData });

  const dispatch = useDispatch();
  useEffect(() => {
    if (open) {
      setData(emptyNewLeaveData);
    }
  }, [open]);

  async function onNewLeaveSubmit(data) {
    const newData = { ...data };
    try {
      const { data } = await createLeave(newData, user.token);
      dispatch(showAlert(data.msg));
      setOpen(false);
      onRefresh();
    } catch (err) {
      handleAxiosError(err, dispatch);
      setOpen(false);
    }
  }

  return (
    <Dialog
      open={open}
      onClose={() => {
        setOpen(false);
      }}
    >
      <DialogTitle>Apply for Leave</DialogTitle>
      <Box component="form" onSubmit={onNewLeaveSubmit}>
        <DialogContent>
          <Grid container spacing={2}>
            {/* Form fields */}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpen(false);
            }}
            className="cancel-button"
          >
            Cancel
          </Button>
          <Button
            className="blue-button"
            onClick={handleSubmit(onNewLeaveSubmit)}
            type="submit"
          >
            Submit
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
function disablePrevDates(startDate) {
  const startSeconds = Date.parse(startDate);
  return (date) => {
    return Date.parse(date) < startSeconds;
  };
}
